import { render, staticRenderFns } from "./MeetingRoomModal.vue?vue&type=template&id=1960fbea"
import script from "./MeetingRoomModal.vue?vue&type=script&lang=js"
export * from "./MeetingRoomModal.vue?vue&type=script&lang=js"
import style0 from "./MeetingRoomModal.vue?vue&type=style&index=0&id=1960fbea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports